import { Platte } from '@icon-park/react'
import style from './index.module.less'
import { ColorPicker, Popover } from 'antd'
import React, {useEffect, useState} from 'react'
import img from './imgs/colorPicker.png'
import {getImagePathWithTheme, imgPathPerfix, isDarkMode} from "@/utils";
import {t} from "i18next";
import {KEY_FILE_DIR, KEY_LAST_CARD_FONT_COLOR, MAX_Z_INDEX} from "@/Const";
import {getCardFontColor} from "@/Icon";

const ColorPickers = ({ editor,updateEditCardHtml }: any) => {

    const getDefaultColorListBackground = ()=>{
        return [
            'transparent', '#626770', '#5C4336', '#805536', '#7E6E35', '#43734F', '#425866', '#614885', '#794462', '#7A4443'
        ]
    }

    const getDefaultColorList = ()=>{
        return [
            isDarkMode()?'#FFFFFF':'#333333', '#AEAEAE', '#FF0600', '#FFA000', '#FFDD18', '#16A34A', '#2080D4', '#8500FF', '#FF0090', '#C34500'
        ];
    }

    const WHITE_COLOR_BACKGROUND =[
        'transparent', '#D0D0D0', '#F8C5BC', '#FAE6B7', '#FEF8BD', '#D0FDE0', '#DCEBFD', '#EEE4F8', '#FFE5F1', '#FDE2E4'
    ]

    const [selectColor,setSelectColor] = useState('#333333');
    const [colorList, setColorList] = useState<string[]>(getDefaultColorList())

    const [colorListBackground, setColorListBackground] = useState<string[]>(getDefaultColorListBackground());

    const [,updateState] = useState();
    const forceUpdate = React.useCallback(()=>updateState({}),[]);



    useEffect(() => {
        refreshColor();

        window.refreshList['updateTheme_color_picker'] = refreshTheme;

        return ()=>{
            delete window.refreshList['updateTheme_color_picker'];
        }
    }, []);

    /**
     * 设置颜色
     */
    function refreshColor(){
        setColorList(getDefaultColorList());
        let szLastColor = localStorage.getItem(KEY_LAST_CARD_FONT_COLOR) || '#000000';
        if (!isDarkMode()){
            setColorListBackground(WHITE_COLOR_BACKGROUND);
        }else{
            //转成暗色
            if (szLastColor == '#000000'){
                szLastColor = '#FFFFFF';
            }
            setColorListBackground(getDefaultColorListBackground());
        }
        setSelectColor(szLastColor);
    }

    /**
     * 刷新主题.
     */
    function refreshTheme(){
        refreshColor();
        forceUpdate();
    }

    return (
        <div className={style.ColorPickerStyle} style={{zIndex:`${MAX_Z_INDEX}`}}>
            <Popover zIndex={MAX_Z_INDEX} arrow={false} placement={'bottom'} content={
                <div className={style.colorPicker}>
                    <span className='font-family-medium ml-6'>{t("Color")}</span>
                    <ul style={{marginTop:'6px'}}>
                        {
                            colorList.map(item =>
                                <li key={item} style={{color: item,border:isDarkMode()?'1px solid #656565':''}} onClick={() => {
                                    localStorage.setItem(KEY_LAST_CARD_FONT_COLOR,item);
                                    setSelectColor(item);
                                    editor.chain().focus().setColor(item).run()
                                    // editor.chain().focus().setColor(item).blur().run()
                                    if (updateEditCardHtml) {
                                        updateEditCardHtml();
                                    }
                                }}
                                    className={editor?.getAttributes?.("textStyle")?.color === item ? style.act : null}> A </li>)
                        }
                        {/* <li>
                            <ColorPicker onChange={(e, color) => {
                                editor.chain().focus().setColor(color).run()

                            }}><img src={img} alt="" /> </ColorPicker>
                        </li> */}
                    </ul>
                    <div style={{height: '16px'}}></div>
                    <span className='font-family-medium ml-6'>{t("Background")}</span>
                    <div style={{height: '6px'}}></div>
                    <ul>
                        {
                            colorListBackground.map(item =>
                                <li key={item} style={{backgroundColor: item,color:isDarkMode()?'white':'black',}} onClick={() => {
                                    let szColor = item;
                                    if (szColor == '#FFFFFF' || szColor == '#000000' || szColor == '#2C2C2C') {
                                        szColor = 'transparent';
                                    }
                                    editor.chain().focus().setBackgroundColor(szColor).run()
                                    // editor.chain().focus().setHighlight({ color: item }).blur().run()
                                    if (updateEditCardHtml) {
                                        updateEditCardHtml();
                                    }
                                }}
                                    className={editor?.getAttributes?.("textStyle")?.backgroundColor === item ? style.act : null}>
                                    <span style={{opacity:item == 'transparent'?'0':'1'}}>A</span>
                                    {
                                        item == 'transparent' &&
                                        <img className={'img-16'} src={getImagePathWithTheme('card_no_background.svg')}/>
                                    }
                                </li>)
                        }
                        {/* <li>
                            <ColorPicker onChange={(e, color) => {
                                editor.chain().focus().setHighlight({ color }).run()

                            }}><img src={img} alt="" /> </ColorPicker>
                        </li> */}
                    </ul>
                </div>
            }>
                {/*<Platte theme="outline" size="16" fill="#333" />*/}
                <div className='flex-row-vertical-center' style={{backgroundColor:'transparent'}} onClick={()=>{
                    editor.chain().focus().setColor(selectColor).run()
                    // editor.chain().focus().setColor(item).blur().run()
                    if (updateEditCardHtml) {
                        updateEditCardHtml();
                    }
                }}>
                    <span className='img-24' style={{marginTop:'-7px'}}>{getCardFontColor(selectColor)}</span>
                    <img className='img-24' style={{marginLeft:'-1px'}} src={getImagePathWithTheme('note_tool_dropdown')}/>
                </div>

            </Popover>
        </div>
    )
}
export default ColorPickers









































